import { Link } from 'react-router-dom';
import { getHotGames } from '@/mocks/games';

export default function HotGamesSection() {
  const hotGames = getHotGames();

  return (
    <section className="w-full max-w-7xl mx-auto px-4 md:px-6 py-14 md:py-20">
      <div className="flex items-center justify-between mb-8">
        <div>
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-900 font-bold">
            热门推荐
          </h2>
          <p className="text-sm text-foreground-500 mt-1">
            当前最受玩家欢迎的黄游戏精选
          </p>
        </div>
        <Link
          to="/category/rpg"
          className="hidden sm:flex items-center gap-1 text-sm text-primary-600 hover:text-primary-700 font-medium transition-colors cursor-pointer whitespace-nowrap"
        >
          查看全部
          <i className="ri-arrow-right-line"></i>
        </Link>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-5">
        {hotGames.map((game) => (
          <Link
            key={game.id}
            to={`/article/${game.slug}`}
            className="group bg-background-50 rounded-xl border border-background-200/70 overflow-hidden hover:border-primary-300/60 transition-all duration-300 cursor-pointer flex flex-col"
          >
            <div className="relative w-full aspect-[16/10] overflow-hidden">
              <img
                src={game.imageUrl}
                alt={game.title}
                title={game.title}
                className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
              />
              <div className="absolute top-3 left-3 px-2.5 py-1 bg-primary-500 text-background-50 text-xs font-medium rounded-md">
                {game.category}
              </div>
              <div className="absolute top-3 right-3 flex items-center gap-1 px-2 py-1 bg-background-50/90 backdrop-blur-sm rounded-md text-xs font-medium text-foreground-700">
                <i className="ri-star-fill text-primary-500 text-xs"></i>
                {game.rating}
              </div>
            </div>
            <div className="p-4 flex flex-col gap-2 flex-1">
              <h3 className="font-heading text-base text-foreground-900 font-bold group-hover:text-primary-600 transition-colors line-clamp-1">
                {game.title}
              </h3>
              <p className="text-xs text-foreground-500 line-clamp-2 leading-relaxed">
                {game.description}
              </p>
              <div className="flex items-center gap-2 flex-wrap mt-auto pt-2">
                {game.tags.slice(0, 3).map((tag) => (
                  <span
                    key={tag}
                    className="px-2 py-0.5 bg-secondary-100 text-secondary-700 text-xs rounded-md whitespace-nowrap"
                  >
                    {tag}
                  </span>
                ))}
              </div>
            </div>
          </Link>
        ))}
      </div>
    </section>
  );
}